<div id="attributes-container-filters" class="selects-container">
  <app-wallet-select
    id="attributes-select-wallet"
    class="wallet-select"
    [(ngModel)]="selectedWallet"
    [showWalletTypeIcon]="true"
    [disabled]="isLoadingAttributes"
    [enableAutoSelect]="true"
    (selectionChange)="onWalletSelect($event)"
    data-testid="wallet-select"
  ></app-wallet-select>
</div>

<div id="attributes-container-last-update" class="last-period-container">
  <div>
    <span i18n="@@dateLastUpdate">Fecha de última actualización:</span>
    <strong id="attributes-lbl-last-update">{{ lastProcessingDate }}</strong>
  </div>
  <app-icon
    name="help_outlined"
    size="24"
    alt="Help icon"
    [color]="'#1976d2'"
    i18n-matTooltip
    matTooltip="Los atributos se actualizan semanalmente."
  ></app-icon>
</div>

<app-mode-provider
  [ngClass]="{ 'show-chart': true, 'hide-chart': isLoadingAttributes || !indicators.length }"
  [templateModes]="[
    {
      ref: el1,
      mode: 'Rango_Dashboard',
      icon: 'equalizer',
      text: 'Grafico de barras',
    },
  ]"
  >
  <ng-template #el1>
    <app-charts-all-ind-cl id="attributes-chart-all-ind" width="100%"> </app-charts-all-ind-cl>
  </ng-template>
</app-mode-provider>

@if (isLoadingAttributes) {
  <div id="attributes-loader-container" class="loading-container">
    <app-ellipsis-loading [id]="'attributes-ellipsis-loader'"></app-ellipsis-loading>
    <span id="attributes-lbl-loading" i18n="@@loadingInformation">Cargando información</span>
  </div>
}

@if (!isLoadingAttributes && !indicators.length) {
  <div id="attributes-empty-container" class="no-data-container">
    @if (hasError) {
      <img id="attributes-img-error" src="assets/images/danger.svg" alt="Error" width="80" />
      <span id="attributes-lbl-error" i18n="@@errorRetrievingData">Error al intentar recuperar los datos.</span>
    } @else {
      <img id="attributes-img-warning" src="assets/images/warning.svg" alt="Warning" width="80" />
      <span id="attributes-lbl-warning" i18n="@@noDataDisplay">No hay datos para mostrar.</span>
    }
  </div>
}
